module.exports = __webpack_public_path__ + "img/x.01d75450.svg";